import React, { useEffect, useState } from 'react';
import { X, Gift, Book, Heart, Shield, Zap } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
const mainItems = [{
  icon: Book,
  label: 'Guía PDF "El Apoyo Incondicional"'
}];
const bonusItems = [{
  icon: Gift,
  label: 'Sistema de 7 Días'
}];
export function ExitIntentPopup() {
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    const hasShown = sessionStorage.getItem('exitPopupShown');
    if (hasShown) return;
    const showPopup = () => {
      setIsOpen(true);
      sessionStorage.setItem('exitPopupShown', 'true');
    };
    const faqObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          showPopup();
          faqObserver.disconnect();
        }
      });
    }, {
      threshold: 0.15
    });
    const checkFaq = setInterval(() => {
      const faqEl = document.getElementById('faq-section');
      if (faqEl) {
        faqObserver.observe(faqEl);
        clearInterval(checkFaq);
      }
    }, 500);
    let mouseLeaveHandler: ((e: MouseEvent) => void) | null = null;
    const armTimer = setTimeout(() => {
      mouseLeaveHandler = (e: MouseEvent) => {
        if (e.clientY <= 0) {
          showPopup();
        }
      };
      document.addEventListener('mouseleave', mouseLeaveHandler);
    }, 5000);
    return () => {
      faqObserver.disconnect();
      clearInterval(checkFaq);
      clearTimeout(armTimer);
      if (mouseLeaveHandler) {
        document.removeEventListener('mouseleave', mouseLeaveHandler);
      }
    };
  }, []);
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  const handleClose = () => setIsOpen(false);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[2000] flex items-center justify-center p-2 sm:p-4 bg-black/70 backdrop-blur-sm animate-fade-in" onClick={handleClose} data-id="element-72">
      <div className="relative w-full max-w-md bg-gradient-to-br from-[#1A1035] to-[#2D1B69] border-[2px] border-[#7C3AED] rounded-xl shadow-2xl p-4 sm:p-6 animate-scale-in" onClick={e => e.stopPropagation()} data-id="element-73">
        {/* Close Button */}
        <button onClick={handleClose} className="absolute top-3 right-3 text-gray-400 hover:text-white transition-colors z-10" aria-label="Cerrar" data-id="element-74">
          <X size={22} data-id="element-75" />
        </button>

        {/* Header */}
        <div className="flex flex-col items-center mb-3 sm:mb-5" data-id="element-76">
          <div className="w-11 h-11 sm:w-16 sm:h-16 rounded-full bg-gradient-to-br from-[#7C3AED] to-[#D4A017] flex items-center justify-center shadow-[0_0_20px_rgba(124,58,237,0.4)] mb-2 sm:mb-4" data-id="element-77">
            <Gift size={20} className="text-white sm:hidden" data-id="element-78" />
            <Gift size={32} className="text-white hidden sm:block" data-id="element-79" />
          </div>
          <h2 className="text-base sm:text-xl font-bold text-white font-['Montserrat'] leading-tight text-center" data-id="element-80">
            Espera — no te vayas sin esto
          </h2>
          <p className="text-[#A78BFA] text-xs sm:text-sm font-['Poppins'] mt-1 text-center" data-id="element-81">
            Todo lo que te llevás hoy con El Apoyo Incondicional:
          </p>
        </div>

        {/* Main Items List */}
        <div className="space-y-1.5 sm:space-y-3 mb-2 sm:mb-4" data-id="element-82">
          {mainItems.map((item, i) => <div key={i} className="flex items-center gap-2.5 sm:gap-3 bg-[#1A1035]/80 border border-[#2D1B69] rounded-lg py-2 px-2.5 sm:p-3" data-id="element-83">
              <div className="flex-shrink-0 w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-[#7C3AED]/20 flex items-center justify-center text-[#A78BFA]" data-id="element-84">
                <item.icon size={14} className="sm:hidden" data-id="element-85" />
                <item.icon size={16} className="hidden sm:block" data-id="element-86" />
              </div>
              <span className="text-white text-xs sm:text-sm font-medium font-['Poppins'] leading-tight" data-id="element-87">
                {item.label}
              </span>
            </div>)}
        </div>

        {/* Bonus Section */}

        <div className="grid grid-cols-1 gap-1.5 sm:grid-cols-1 sm:space-y-0 sm:gap-3 mb-3 sm:mb-6" data-id="element-88">
          {bonusItems.map((item, i) => {})}
        </div>

        {/* Pricing */}
        <div className="text-center mb-3 sm:mb-6" data-id="element-89">
          <div className="flex items-center justify-center gap-2 sm:gap-3 mb-0.5" data-id="element-90">
            <span className="text-[#9CA3AF] text-xs sm:text-sm" data-id="element-91">
              Todo por solo
            </span>
            <span className="text-[#9CA3AF] line-through text-sm sm:text-lg font-medium" data-id="element-92">
              $19.99
            </span>
            <span className="bg-[#DC2626] text-white text-[10px] sm:text-xs px-1.5 sm:px-2 py-0.5 rounded-full font-bold" data-id="element-93">
              -61%
            </span>
          </div>
          <div className="text-[#D4A017] text-3xl sm:text-4xl font-[800] font-['Montserrat']" data-id="element-94">
            $7.77 USD
          </div>
          <div className="flex items-center justify-center gap-1 text-[#DC2626] text-[10px] sm:text-xs font-bold animate-pulse mt-0.5" data-id="element-95">
            <Zap size={10} fill="currentColor" data-id="element-96" />
            <span data-id="element-97">Oferta por tiempo limitado</span>
          </div>
        </div>

        {/* CTA */}
        <a href="https://oriammarketing.com/cart/45555442090182:1" onClick={() => trackAddToCart()} className="block w-full bg-gradient-to-br from-[#7C3AED] to-[#6D28D9] text-white border-none py-3 sm:p-4 text-sm sm:text-base font-bold rounded-[50px] shadow-[0_8px_20px_rgba(124,58,237,0.3)] text-center no-underline uppercase font-['Montserrat'] animate-pulse-custom hover:transform hover:-translate-y-1 hover:scale-[1.02] hover:shadow-[0_8px_20px_rgba(124,58,237,0.5)] transition-all duration-300" data-id="element-98">
          OFERTA EXCLUSIVA — $7.77 USD
        </a>

        <p className="text-center text-[#A78BFA] text-[10px] sm:text-xs font-medium flex items-center justify-center gap-1 mt-2 sm:mt-3" data-id="element-99">
          <Zap size={10} data-id="element-100" /> Precio especial hoy
        </p>

        <button onClick={handleClose} className="block w-full text-center text-[#6B7280] text-xs sm:text-sm hover:text-[#9CA3AF] transition-colors underline decoration-dotted underline-offset-4 mt-2 sm:mt-3" data-id="element-101">
          No, prefiero seguir como estoy
        </button>
      </div>
    </div>;
}